// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as EventListenerManager$OrcaPaymentPage from "../Utilities/EventListenerManager.bs.js";

function postMessageToIframes(iframes, message) {
  iframes.forEach(function (ifR) {
        Window$OrcaPaymentPage.iframePostMessage(ifR, message);
      });
}

function postResponseToIframes(iframes, key, response) {
  postMessageToIframes(iframes, Object.fromEntries([[
              key,
              response
            ]]));
}

function setOverlayLoading(iframes, isLoading) {
  postResponseToIframes(iframes, "updateIntentLoading", isLoading);
}

function waitForReady() {
  return new Promise((function (resolve, param) {
                var onMessage = function ($$event) {
                  var dict = Utils$OrcaPaymentPage.getDictFromJson($$event.data);
                  if (Utils$OrcaPaymentPage.getBool(dict, "ready", false)) {
                    return resolve();
                  }
                  
                };
                EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", onMessage, "updateIntent.ready");
              }));
}

async function getNewCredentials(callback, currentClientSecret) {
  var callbackResult = await callback();
  var newSdkAuthorization = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(callbackResult), "sdkAuthorization", "");
  var sdkAuthorizationData = Utils$OrcaPaymentPage.getSdkAuthorizationData(newSdkAuthorization);
  var cs = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationData.clientSecret);
  var newClientSecret = cs !== undefined ? cs : currentClientSecret;
  return [
          newSdkAuthorization,
          newClientSecret
        ];
}

function sendElementsUpdateToIframes(iframes, newSdkAuthorization, newClientSecret) {
  postMessageToIframes(iframes, Object.fromEntries([
            [
              "ElementsUpdate",
              true
            ],
            [
              "sdkAuthorization",
              newSdkAuthorization
            ],
            [
              "clientSecret",
              newClientSecret
            ],
            [
              "options",
              {}
            ]
          ]));
}

function updateIntentInProgressResponse() {
  return Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", "An updateIntent operation is already in progress.");
}

function confirmBlockedResponse() {
  return Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", "Cannot confirm payment while updateIntent is in progress.");
}

function confirmBlockedResponseForSession() {
  return Utils$OrcaPaymentPage.handleFailureResponse("Cannot confirm payment while updateIntent is in progress.", "update_intent_error");
}

function isErrorResponse(json) {
  var dict = Core__JSON.Classify.classify(json);
  if (typeof dict !== "object") {
    return true;
  } else if (dict.TAG === "Object") {
    return Core__Option.isSome(dict._0["error"]);
  } else {
    return false;
  }
}

function forwardPromiseToIframes(iframes, promise, key) {
  return promise.then(function (json) {
              postResponseToIframes(iframes, key, json);
              return Promise.resolve(json);
            });
}

function mountPreMountLoaderIframe(publishableKey, sdkSessionId, endpoint, customPodUri, isTestMode, isSdkParamsEnabled, selectorString, currentClientSecret, currentSdkAuthorization, paymentIdOpt, profileIdOpt) {
  var paymentId = paymentIdOpt !== undefined ? paymentIdOpt : "";
  var profileId = profileIdOpt !== undefined ? profileIdOpt : "";
  var existingIframe = document.querySelector("#orca-payment-element-iframeRef-" + selectorString);
  if (!(existingIframe == null)) {
    var wrapperDiv = document.querySelector("#orca-element-" + selectorString);
    if (wrapperDiv == null) {
      existingIframe.remove();
    } else {
      wrapperDiv.remove();
    }
  }
  var componentType = "preMountLoader";
  var merchantHostname = window.location.hostname;
  var isTestModeValue = Utils$OrcaPaymentPage.getStringFromBool(isTestMode);
  var isSdkParamsEnabledValue = Utils$OrcaPaymentPage.getStringFromBool(isSdkParamsEnabled);
  var iframeDivHtml = "<div id=\"orca-element-" + selectorString + "\" style= \"height: 0px; width: 0px; display: none;\"  class=\"" + componentType + "\">\n      <div id=\"orca-fullscreen-iframeRef-" + selectorString + "\"></div>\n        <iframe\n          id=\"orca-payment-element-iframeRef-" + selectorString + "\"\n          name=\"orca-payment-element-iframeRef-" + selectorString + "\"\n          title=\"Orca Payment Element Frame\"\n          src=\"" + ApiEndpoint$OrcaPaymentPage.sdkDomainUrl + "/index.html?fullscreenType=" + componentType + "&publishableKey=" + publishableKey + "&clientSecret=" + currentClientSecret + "&sessionId=" + sdkSessionId + "&endpoint=" + endpoint + "&merchantHostname=" + merchantHostname + "&customPodUri=" + customPodUri + "&isTestMode=" + isTestModeValue + "&isSdkParamsEnabled=" + isSdkParamsEnabledValue + "&sdkAuthorization=" + currentSdkAuthorization + "&paymentId=" + paymentId + "&profileId=" + profileId + "\"\n          allow=\"*\"\n          name=\"orca-payment\"\n          style=\"outline: none;\"\n        ></iframe>\n      </div>";
  var iframeDiv = document.createElement("div");
  iframeDiv.innerHTML = iframeDivHtml;
  document.body.appendChild(iframeDiv);
  return document.querySelector("#orca-payment-element-iframeRef-" + selectorString);
}

function unMountPreMountLoaderIframe(selectorString) {
  var wrapperDiv = document.querySelector("#orca-element-" + selectorString);
  if (!(wrapperDiv == null)) {
    wrapperDiv.remove();
    return ;
  }
  
}

function setupPreMountLoaderPromises(publishableKey, sdkSessionId, endpoint, customPodUri, isTestMode, isSdkParamsEnabled, selectorString, currentClientSecret, currentSdkAuthorization, paymentIdOpt, profileIdOpt) {
  var paymentId = paymentIdOpt !== undefined ? paymentIdOpt : "";
  var profileId = profileIdOpt !== undefined ? profileIdOpt : "";
  var preMountLoaderIframeDiv = mountPreMountLoaderIframe(publishableKey, sdkSessionId, endpoint, customPodUri, isTestMode, isSdkParamsEnabled, selectorString, currentClientSecret, currentSdkAuthorization, paymentId, profileId);
  var preMountLoaderMountedPromise = new Promise((function (resolve, _reject) {
          var preMountLoaderIframeCallback = function (ev) {
            var json = ev.data;
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (Core__Option.isSome(dict["preMountLoaderIframeMountedCallback"])) {
              return resolve(true);
            } else if (Core__Option.isSome(dict["preMountLoaderIframeUnMount"])) {
              return unMountPreMountLoaderIframe(selectorString);
            } else {
              return ;
            }
          };
          EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", preMountLoaderIframeCallback, "onPreMountLoaderIframeCallback");
        }));
  var createDataPromise = function (dataKey, listenerName, sendKey) {
    return preMountLoaderMountedPromise.then(function (param) {
                return new Promise((function (resolve, param) {
                              var handleData = function ($$event) {
                                var json = $$event.data;
                                var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                                if (Utils$OrcaPaymentPage.getString(dict, "data", "") === dataKey) {
                                  return resolve(Utils$OrcaPaymentPage.getJsonFromDict(dict, "response", null));
                                }
                                
                              };
                              EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleData, listenerName);
                              var msg = Object.fromEntries([[
                                      sendKey,
                                      true
                                    ]]);
                              Window$OrcaPaymentPage.iframePostMessage(preMountLoaderIframeDiv, msg);
                            }));
              });
  };
  var paymentMethodsData = createDataPromise("payment_methods", "onPaymentMethodsData-shared", "sendPaymentMethodsResponse");
  var customerPaymentMethodsData = createDataPromise("customer_payment_methods", "onCustomerPaymentMethodsData-shared", "sendCustomerPaymentMethodsResponse");
  var sessionTokensData = createDataPromise("session_tokens", "onSessionTokensData-shared", "sendSessionTokensResponse");
  var requestMsg = Object.fromEntries([[
          "requestPreMountLoaderMountedCallback",
          true
        ]]);
  Window$OrcaPaymentPage.iframePostMessage(preMountLoaderIframeDiv, requestMsg);
  Core__Promise.$$catch(Promise.all([
              paymentMethodsData,
              customerPaymentMethodsData,
              sessionTokensData
            ]).then(function (param) {
            var msg = Object.fromEntries([[
                    "cleanUpPreMountLoaderIframe",
                    true
                  ]]);
            Window$OrcaPaymentPage.iframePostMessage(preMountLoaderIframeDiv, msg);
            return Promise.resolve();
          }), (function (param) {
          return Promise.resolve();
        }));
  return [
          paymentMethodsData,
          customerPaymentMethodsData,
          sessionTokensData
        ];
}

async function performUpdateIntent(isUpdateIntentInProgress, clientSecretRef, sdkAuthorizationRef, paymentMethodsDataPromise, customerPaymentMethodsDataPromise, sessionTokensDataPromise, iframes, callback, publishableKey, sdkSessionId, endpoint, customPodUri, isTestMode, isSdkParamsEnabled, selectorString, shouldWaitForReady) {
  if (isUpdateIntentInProgress.contents) {
    return Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", "An updateIntent operation is already in progress.");
  }
  isUpdateIntentInProgress.contents = true;
  var response;
  try {
    var match = await getNewCredentials(callback, clientSecretRef.contents);
    var newClientSecret = match[1];
    var newSdkAuthorization = match[0];
    var match$1 = setupPreMountLoaderPromises(publishableKey, sdkSessionId, endpoint, customPodUri, isTestMode, isSdkParamsEnabled, selectorString, newClientSecret, newSdkAuthorization, undefined, undefined);
    var newSessionTokensPromise = match$1[2];
    var newCustomerPaymentMethodsPromise = match$1[1];
    var newPaymentMethodsPromise = match$1[0];
    var results = await Promise.all([
          newPaymentMethodsPromise,
          newCustomerPaymentMethodsPromise,
          newSessionTokensPromise
        ]);
    var firstError = results.find(isErrorResponse);
    if (firstError !== undefined) {
      unMountPreMountLoaderIframe(selectorString);
      var errorMessage = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(firstError), "error"), "message", "An API call failed during updateIntent.");
      response = Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", errorMessage);
    } else {
      clientSecretRef.contents = newClientSecret;
      sdkAuthorizationRef.contents = newSdkAuthorization;
      paymentMethodsDataPromise.contents = newPaymentMethodsPromise;
      customerPaymentMethodsDataPromise.contents = newCustomerPaymentMethodsPromise;
      sessionTokensDataPromise.contents = newSessionTokensPromise;
      sendElementsUpdateToIframes(iframes, newSdkAuthorization, newClientSecret);
      var readyPromise = shouldWaitForReady ? Caml_option.some(waitForReady()) : undefined;
      await Promise.all([
            forwardPromiseToIframes(iframes, newPaymentMethodsPromise, "paymentMethodList"),
            forwardPromiseToIframes(iframes, newCustomerPaymentMethodsPromise, "customerPaymentMethods"),
            forwardPromiseToIframes(iframes, newSessionTokensPromise, "sessions")
          ]);
      if (readyPromise !== undefined) {
        await Caml_option.valFromOption(readyPromise);
      }
      response = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
              "status",
              "succeeded"
            ]]);
    }
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    response = e.RE_EXN_ID === Js_exn.$$Error ? Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", Core__Option.getOr(e._1.message, "Something went wrong during updateIntent!")) : Utils$OrcaPaymentPage.getFailedSubmitResponse("update_intent_error", "An unexpected error occurred during updateIntent.");
  }
  isUpdateIntentInProgress.contents = false;
  return response;
}

export {
  postMessageToIframes ,
  postResponseToIframes ,
  setOverlayLoading ,
  waitForReady ,
  getNewCredentials ,
  sendElementsUpdateToIframes ,
  updateIntentInProgressResponse ,
  confirmBlockedResponse ,
  confirmBlockedResponseForSession ,
  isErrorResponse ,
  forwardPromiseToIframes ,
  mountPreMountLoaderIframe ,
  unMountPreMountLoaderIframe ,
  setupPreMountLoaderPromises ,
  performUpdateIntent ,
}
/* Utils-OrcaPaymentPage Not a pure module */
